import { Component, ElementRef, OnInit } from '@angular/core';

@Component({
  selector: 'uex-layout-sidebar-avatar',
  templateUrl: './avatar.component.html',
  host: {
    class: 'uex-layout-sidebar-avatar'
  }
})

export class LayoutSidebarAvatarComponent implements OnInit {
  constructor(
    public elementRef: ElementRef
  ) { }

  ngOnInit() { }
}
